/**
 * @file The key `analyticsAnswers` holds one request's answer under:
 * `query/level/period`, followed by `/grain/group` for a series request.
 * Consumers: `useAnalyticsAnswer`, which writes and reads it, and the page
 * shell, which reads the answers on screen. Every request field is a closed
 * enum, so two requests share a key only when they are the same request.
 */
import type { NamedQueryRequest } from '#types';

export const analyticsAnswerKey = ({
  query,
  level,
  parameters: { period, grain, group },
}: NamedQueryRequest): string =>
  [query, level, period, grain, group]
    .filter((part) => part !== undefined)
    .join('/');
